import React from 'react';
import { FiShield, FiTool, FiBook } from 'react-icons/fi';

const services = [
    {
        icon: <FiTool size={32} className="text-red-500 mb-4" />,
        title: "Jeopardy & Attack-Defense CTFs",
        description:
            "Immersive Capture The Flag (CTF) environments designed to sharpen your team’s offensive and defensive cybersecurity skills.",
        items: [
            "Real-world CTF Challenges",
            "Red & Blue Team Scenarios",
            "Customizable Lab Environments",
            "Boot2Root & Forensics Tracks"
        ],
    },
    {
        icon: <FiShield size={32} className="text-red-500 mb-4" />,
        title: "Table Top Exercises",
        description:
            "Strategic simulations for leadership and IT teams to test decision-making under realistic cyber crisis conditions.",
        items: [
            "Custom Crisis Scenarios",
            "Executive-Level Engagement",
            "Incident Response Playbooks",
            "Post-Mortem Analysis & Review"
        ],
    },
    {
        icon: <FiBook size={32} className="text-red-500 mb-4" />,
        title: "Incident Handling Training",
        description:
            "End-to-end training on identifying, analyzing, and mitigating cybersecurity incidents using real-world tools and techniques.",
        items: [
            "Log Analysis & Threat Hunting",
            "SIEM Tools & Use Cases",
            "Hands-on Breach Simulations",
            "Playbook Development"
        ],
    },
    {
        icon: <FiBook size={32} className="text-red-500 mb-4" />,
        title: "Boot2Root Challenges",
        description:
            "Gamified penetration testing environments for learners to exploit vulnerabilities and gain root access—completely hands-on.",
        items: [
            "Beginner to Advanced Machines",
            "Linux & Windows Targets",
            "In-browser Exploitation Labs",
            "Progress Tracking & Leaderboards"
        ],
    },
];

const Services = () => {
    return (
        <section id="services" className="bg-[#1a1a1a] text-white px-6 md:px-16 py-20">
            <div className="text-center mb-12">
                <h2 className="text-3xl font-bold mb-2">
                    <span className="text-white">Our</span> <span className="text-red-500">Trainings</span>
                </h2>
                <p className="text-gray-400 max-w-2xl mx-auto">
                    Elevate your team’s cybersecurity readiness with our industry-grade, scenario-based trainings. All programs are customizable to your organizational needs and delivered by top-tier professionals.
                </p>
            </div>

            <div className="grid gap-8 md:grid-cols-4">
                {services.map((service, index) => (
                    <div
                        key={index}
                        className="bg-[#1a1a1a] p-6 rounded-lg shadow-lg border border-gray-700 hover:border-red-500 transition"
                        data-aos="zoom-in"
                        data-aos-delay={index * 100}
                        data-aos-duration="800"
                    >
                        <div className="flex flex-col items-center">
                            {service.icon}
                            <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                            <p className="text-gray-400 mb-4 text-center">{service.description}</p>
                            <ul className="text-sm text-gray-300 space-y-1 mb-4 list-disc list-inside">
                                {service.items.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Services;
